var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 201,
    viewBox: "0 0 160 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_1928)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650635,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6037 159.651V155.347H27.1637V153.811H20.6037V150.483H27.4037V148.931H18.8757V159.651H20.6037ZM30.4162 159.651V155.187C30.4162 153.763 30.9762 153.011 32.3362 153.011C33.5202 153.011 34.0002 153.539 34.0002 154.675V155.379H35.7122V154.339C35.7122 152.835 34.9282 151.539 33.1202 151.539C31.4882 151.539 30.6242 152.563 30.3842 153.843H30.2722V151.699H28.6882V159.651H30.4162ZM40.7976 159.811C43.1656 159.811 44.8296 158.643 44.8296 156.947V156.803H43.1016V156.931C43.1016 157.875 42.4136 158.419 40.7496 158.419C38.9096 158.419 38.1576 157.603 38.0936 156.067H44.8456C44.8936 155.827 44.9096 155.603 44.9096 155.315C44.9096 152.899 43.2296 151.539 40.7656 151.539C38.1736 151.539 36.4776 153.203 36.4776 155.683C36.4776 158.339 38.1896 159.811 40.7976 159.811ZM40.7336 152.899C42.4296 152.899 43.2776 153.603 43.2776 155.075V155.107H38.1096C38.2056 153.683 38.9736 152.899 40.7336 152.899ZM50.2038 159.811C52.5718 159.811 54.2358 158.643 54.2358 156.947V156.803H52.5078V156.931C52.5078 157.875 51.8198 158.419 50.1558 158.419C48.3158 158.419 47.5638 157.603 47.4998 156.067H54.2518C54.2998 155.827 54.3158 155.603 54.3158 155.315C54.3158 152.899 52.6358 151.539 50.1718 151.539C47.5798 151.539 45.8838 153.203 45.8838 155.683C45.8838 158.339 47.5958 159.811 50.2038 159.811ZM50.1398 152.899C51.8358 152.899 52.6838 153.603 52.6838 155.075V155.107H47.5158C47.6118 153.683 48.3798 152.899 50.1398 152.899ZM20.6037 179.651V175.187C20.6037 173.763 21.1637 173.011 22.5237 173.011C23.7077 173.011 24.1877 173.539 24.1877 174.675V175.379H25.8997V174.339C25.8997 172.835 25.1157 171.539 23.3077 171.539C21.6757 171.539 20.8117 172.563 20.5717 173.843H20.4597V171.699H18.8757V179.651H20.6037ZM30.9851 179.811C33.3531 179.811 35.0171 178.643 35.0171 176.947V176.803H33.2891V176.931C33.2891 177.875 32.6011 178.419 30.9371 178.419C29.0971 178.419 28.3451 177.603 28.2811 176.067H35.0331C35.0811 175.827 35.0971 175.603 35.0971 175.315C35.0971 172.899 33.4171 171.539 30.9531 171.539C28.3611 171.539 26.6651 173.203 26.6651 175.683C26.6651 178.339 28.3771 179.811 30.9851 179.811ZM30.9211 172.899C32.6171 172.899 33.4651 173.603 33.4651 175.075V175.107H28.2971C28.3931 173.683 29.1611 172.899 30.9211 172.899ZM39.8473 178.931C41.6553 178.931 42.7273 178.067 43.0153 176.867H43.1273V178.819C43.1273 180.595 42.4713 181.091 40.6633 181.091C38.9673 181.091 38.2953 180.659 38.2953 179.507H36.5833C36.5833 181.427 38.2153 182.531 40.5673 182.531C43.1753 182.531 44.8393 181.395 44.8393 178.723V171.699H43.2553V173.683H43.1593C42.8713 172.291 41.6233 171.539 39.9593 171.539C37.5433 171.539 36.0713 173.027 36.0713 175.235C36.0713 177.443 37.4793 178.931 39.8473 178.931ZM37.8153 175.235C37.8153 173.603 38.7913 173.043 40.4553 173.043C42.1353 173.043 43.1273 173.731 43.1273 175.075V175.299C43.1273 176.707 42.1673 177.443 40.4073 177.443C38.7753 177.443 37.8153 176.867 37.8153 175.235ZM48.1662 170.771V168.931H46.4382V170.771H48.1662ZM48.1662 179.651V171.699H46.4382V179.651H48.1662ZM53.5263 179.811C55.7663 179.811 57.2383 178.931 57.2383 177.443C57.2383 176.131 56.3743 175.491 54.4863 175.251L52.6463 174.995C51.4463 174.835 51.1263 174.611 51.1263 173.987C51.1263 173.235 51.6383 172.915 53.0943 172.915C54.8543 172.915 55.3343 173.411 55.3343 174.355V174.451H57.0463V174.403C57.0463 172.515 55.5743 171.539 53.1423 171.539C50.6943 171.539 49.4303 172.531 49.4303 173.923C49.4303 175.251 50.3423 175.891 51.8463 176.083L54.0223 176.371C55.1583 176.531 55.5423 176.739 55.5423 177.395C55.5423 178.099 55.0783 178.419 53.5263 178.419C51.8623 178.419 51.2383 178.083 51.2383 177.043V176.915H49.5103V176.963C49.5103 178.803 50.9663 179.811 53.5263 179.811ZM63.7011 179.651V178.099H62.2611C61.2691 178.099 60.8211 177.843 60.8211 176.867V173.139H63.7011V171.699H60.8211V169.955H59.1091V171.699H57.7651V173.139H59.1091V176.963C59.1091 178.899 60.1651 179.651 61.8771 179.651H63.7011ZM66.5099 179.651V175.187C66.5099 173.763 67.0699 173.011 68.4299 173.011C69.6139 173.011 70.0939 173.539 70.0939 174.675V175.379H71.8059V174.339C71.8059 172.835 71.0219 171.539 69.2139 171.539C67.5819 171.539 66.7179 172.563 66.4779 173.843H66.3659V171.699H64.7819V179.651H66.5099ZM75.2273 179.811C77.0353 179.811 78.2993 179.011 78.7153 177.667H78.8273V179.651H80.4113V174.819C80.4113 172.915 79.2753 171.539 76.7473 171.539C74.2193 171.539 72.7153 172.899 72.7153 174.707V174.771H74.4273V174.707C74.4273 173.539 75.1473 173.059 76.6193 173.059C78.1393 173.059 78.7153 173.523 78.7153 174.835V175.299L75.0993 175.683C73.5313 175.859 72.5393 176.499 72.5393 177.731C72.5393 179.043 73.5793 179.811 75.2273 179.811ZM74.2673 177.619C74.2673 176.995 74.6993 176.787 75.5953 176.675L78.7153 176.323C78.7153 177.891 77.4993 178.563 75.6913 178.563C74.6993 178.563 74.2673 178.259 74.2673 177.619ZM87.1698 179.651V178.099H85.7298C84.7378 178.099 84.2898 177.843 84.2898 176.867V173.139H87.1698V171.699H84.2898V169.955H82.5778V171.699H81.2338V173.139H82.5778V176.963C82.5778 178.899 83.6338 179.651 85.3458 179.651H87.1698ZM89.9787 170.771V168.931H88.2507V170.771H89.9787ZM89.9787 179.651V171.699H88.2507V179.651H89.9787ZM95.6428 179.811C98.2988 179.811 100.075 178.131 100.075 175.683C100.075 173.203 98.2988 171.539 95.6428 171.539C93.0028 171.539 91.2268 173.203 91.2268 175.683C91.2268 178.131 93.0028 179.811 95.6428 179.811ZM95.6428 178.275C93.7228 178.275 92.9228 177.363 92.9228 175.683C92.9228 173.987 93.7228 173.059 95.6428 173.059C97.5788 173.059 98.3788 173.987 98.3788 175.683C98.3788 177.363 97.5788 178.275 95.6428 178.275ZM103.057 179.651V175.715C103.057 173.987 103.841 173.091 105.585 173.091C107.233 173.091 107.905 173.843 107.905 175.331V179.651H109.633V174.867C109.633 173.027 108.545 171.539 106.337 171.539C104.321 171.539 103.265 172.819 103.025 174.163H102.913V171.699H101.329V179.651H103.057Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 24.5205,
    y1: 104.983,
    x2: 24.5205,
    y2: -36.5318,
    stroke: "url(#paint0_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.5205,
    y1: 104.983,
    x2: 60.5205,
    y2: -36.5318,
    stroke: "url(#paint1_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5205,
    y1: 104.983,
    x2: 96.5205,
    y2: -36.5318,
    stroke: "url(#paint2_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.521,
    y1: 104.983,
    x2: 132.521,
    y2: -36.5318,
    stroke: "url(#paint3_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 3.84424,
    x2: 229.941,
    y2: 3.84422,
    stroke: "url(#paint4_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 62.8442,
    x2: 229.941,
    y2: 62.8442,
    stroke: "url(#paint5_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.4453,
    y1: 32.8442,
    x2: 229.941,
    y2: 32.8442,
    stroke: "url(#paint6_linear_51_1928)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_51_1928)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1284 42H56.6024C58.1673 42.0023 59.6674 42.6256 60.7731 43.733C61.8789 44.8404 62.4999 46.3413 62.4999 47.9062V64.3125C63.8923 64.3125 65.2277 63.7594 66.2122 62.7748C67.1968 61.7902 67.7499 60.4549 67.7499 59.0625V42.189C67.7499 39.5552 65.7812 37.2697 63.0879 37.044C62.6955 37.0121 62.3029 36.983 61.9102 36.9565C61.4672 36.103 60.7983 35.3876 59.9765 34.8882C59.1547 34.3889 58.2115 34.1249 57.2499 34.125H54.6249C53.6633 34.1249 52.7201 34.3889 51.8983 34.8882C51.0765 35.3876 50.4076 36.103 49.9647 36.9565C49.5709 36.9827 49.1772 37.0125 48.7869 37.044C46.1584 37.2662 44.2194 39.4485 44.1284 42ZM54.6249 36.75C53.9287 36.75 53.261 37.0266 52.7688 37.5188C52.2765 38.0111 51.9999 38.6788 51.9999 39.375H59.8749C59.8749 38.6788 59.5984 38.0111 59.1061 37.5188C58.6138 37.0266 57.9461 36.75 57.2499 36.75H54.6249Z",
    fill: "#A4D143"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.25 47.9062C36.25 46.0933 37.72 44.625 39.5312 44.625H56.5938C58.4067 44.625 59.875 46.095 59.875 47.9062V67.5938C59.875 69.405 58.405 70.875 56.5938 70.875H39.5312C38.661 70.875 37.8264 70.5293 37.2111 69.9139C36.5957 69.2986 36.25 68.464 36.25 67.5938V47.9062ZM53.0255 55.9457C53.2432 55.6738 53.3439 55.3265 53.3055 54.9802C53.2671 54.634 53.0927 54.3172 52.8207 54.0995C52.5488 53.8818 52.2015 53.7811 51.8552 53.8195C51.509 53.8579 51.1922 54.0323 50.9745 54.3043L46.6415 59.7223L45.0525 58.135C44.8037 57.9032 44.4746 57.7769 44.1346 57.7829C43.7946 57.7889 43.4701 57.9267 43.2297 58.1672C42.9892 58.4076 42.8514 58.7321 42.8454 59.0721C42.8394 59.4121 42.9657 59.7412 43.1975 59.99L45.8225 62.615C45.953 62.7455 46.1097 62.847 46.2821 62.9129C46.4545 62.9788 46.6389 63.0075 46.8233 62.9973C47.0076 62.987 47.1876 62.938 47.3517 62.8535C47.5158 62.7689 47.6602 62.6507 47.7755 62.5065L53.0255 55.944V55.9457Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_51_1928)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_1928",
    x1: 26.0208,
    y1: 168.078,
    x2: 26.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_1928",
    x1: 62.0208,
    y1: 168.078,
    x2: 62.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_1928",
    x1: 98.0208,
    y1: 168.078,
    x2: 98.0208,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_1928",
    x1: 134.021,
    y1: 168.078,
    x2: 134.021,
    y2: 34.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_1928",
    x1: 240.724,
    y1: 4.34424,
    x2: -37.6865,
    y2: 4.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_1928",
    x1: 240.724,
    y1: 63.3442,
    x2: -37.6865,
    y2: 63.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_1928",
    x1: 240.724,
    y1: 33.3442,
    x2: -37.6865,
    y2: 33.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_1928",
    x1: 52,
    y1: 16.5,
    x2: 54.1764,
    y2: 112.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1FBAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703509,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_1928",
    x1: 52,
    y1: 16.5,
    x2: 52,
    y2: 88.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFF981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_1928"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.650635,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness1);
export default __webpack_public_path__ + "static/media/business1.86417e01e388aba5d0fdb5a623dd175a.svg";
export { ForwardRef as ReactComponent };